export default __webpack_public_path__ + "static/media/illustration-home.c8461fe9.svg";